/* eslint-disable no-undef */

import React, { Component } from "react";
import PropTypes from "prop-types";
import Img from "./img";

class ImgList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      likes: 0,
      count: 0,
      email: "",
      showValid: false,
      showEmpty: false
    };

    this.updateInput = this.updateInput.bind(this);
    this.emailSend = this.emailSend.bind(this);
  }

  updateInput(event) {
    this.setState({ email: event.target.value });
  }

  validateEmail(email) {
    return /[^@]+@[^@]+\.[^@]+/gi.test(email);
  }

  emailSend() {
    this.setState({ showEmpty: false, showValid: false });

    var button = document.querySelector(".subscribeCardBtn");
    var validate = (button.getAttribute("data-validate-email") === "true") || false;

    if (validate) {
      if (!this.state.email) {
        this.setState({ showEmpty: true });
      } else if (!this.validateEmail(this.state.email)) {
        this.setState({ showValid: true });
      } else {
        methodist.analytics.pushEvent('content_hub_subscribe_cta_clicked');

        var cookie = button.getAttribute("data-cookie") || "_subscribe_email";

        var expires = new Date();
        expires.setTime(expires.getTime() + 60 * 1000);
        document.cookie = cookie + "=" + encodeURIComponent(this.state.email) + "; samesite=strict; secure; path=/; expires=" + expires.toGMTString();

        location.assign(button.getAttribute("data-href"));
      }
    } else {
      methodist.analytics.pushEvent('content_hub_subscribe_cta_clicked');

      location.assign(button.getAttribute("data-href"));
    }
  }

  render() {
    return (
      <div className="searchCardGrid container">
        <div className="cardLayout">
          {this.props.data.map(img => {
            return img.SubscribeCard ? (
              <div key={img.ItemID} className="subscribe cardDiv">
                <div className="subscribe__inner">
                  <h2 className="subscribeCardTitle">
                    {img.SubscribeCard.Title}
                  </h2>
                  <h4 className="subscribeCardTeaser">
                    {img.SubscribeCard.Teaser}
                  </h4>
                  {img.SubscribeCard.ButtonLink &&
                    img.SubscribeCard.ButtonLabel && (
                      <div>
                        {img.Type === "subscribe" && (
                          <input
                            type="email"
                            value={this.state.email}
                            className="subscribeCardInput"
                            onChange={this.updateInput}
                            placeholder={img.SubscribeCard.WaterMarkText || ""}
                          >
                          </input>
                        )}
                        <button
                          onClick={this.emailSend}
                          data-validate-email={img.Type === "subscribe"}
                          data-href={img.SubscribeCard.ButtonLink}
                          data-cookie={img.SubscribeCard.Cookie}
                          className="subscribeCardBtn"
                        >
                          {img.SubscribeCard.ButtonLabel}
                        </button>
                      </div>
                    )}
                  <div
                    className={
                      "sbcarderrortext " +
                      (this.state.showEmpty ? "show" : "hide")
                    }
                  >
                    Please enter an email
                  </div>
                  <div
                    className={
                      "sbcarderrortextvalid " +
                      (this.state.showValid ? "show" : "hide")
                    }
                  >
                    Please enter a valid email
                  </div>
                </div>
              </div>
            ) : (
              <Img
                key={img.ItemID}
                img={img.ArticleThumbnail}
                video={img.ArticleVideo}
                tags={img.Tags}
                title={img.Title}
                url={img.PageURL}
                posteddate={img.PostedDateFormatted}
                type={img.Type}
                subscribe={img.SubscribeCard}
                hideDate={window.hideDate}
                hideCategory={window.hideCategory}
                playButtonColor={window.playButtonColor}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

ImgList.propTypes = {
  data: PropTypes.array
};

export default ImgList;
